import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

import { classes } from './Dropdowns/styles';

const AddButton = ({
  title,
  onClick,
  children
}: {
  title: string;
  onClick: () => void;
  children: React.ReactNode;
}) => {
  return (
    <Tooltip title={title} placement="top" arrow>
      <IconButton id={`add-button`} sx={classes.iconButton} onClick={onClick}>
        {children}
      </IconButton>
    </Tooltip>
  );
};

export default AddButton;
